import { useAppContext } from "@/provider/common/AppProvider";
import { Box, Card, Text } from "@/ui";
import { Skeleton, useTheme, useMediaQuery } from "@mui/material";
import { formatUTC } from "@/utils/format";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import AddModeratorIcon from "@mui/icons-material/AddModerator";
import { colorPalette } from "@/theme/ThemeProvider";

const Contracts = () => {
  const theme = useTheme();
  // Doit rester cohérent avec le seuil utilisé dans home/index.tsx.
  const isNarrow = useMediaQuery(theme.breakpoints.down(1070));
  const { contract, optionGestion } = useAppContext();

  return (
    <>
      <ContractCard contract={contract} theme={theme} icon={LocalOfferIcon} title={contract?.productName} showIcon isNarrow={isNarrow} />
      <Box flex={isNarrow ? undefined : 0.02} height={isNarrow ? "16px" : undefined} />
      <ContractCard contract={optionGestion} theme={theme} icon={AddModeratorIcon} title="Option Tranquillité" isNarrow={isNarrow} />
    </>
  );
};

const PricingLine = ({ contract, theme }: any) => {
  if (contract?.typeFacturation === 1) {
    return (
      <Box flexDirection="row">
        <Text fontWeight="600" mr={2}>
          Mon taux:
        </Text>
        <Text>{contract?.percentage}% du chiffre d'affaire traité</Text>
      </Box>
    );
  }
  if (contract?.typeFacturation === 2) {
    return (
      <Box flexDirection="row">
        <Text fontWeight="600" mr={2}>
          Mensualité:
        </Text>
        <Text>{contract?.montant}€ / mois</Text>
      </Box>
    );
  }
  return null;
};

const ContractCard = ({ contract, theme, title, showIcon, isNarrow }: any) => {
  if (contract === null) {
    return (
      <Box flex={isNarrow ? undefined : 0.35} width={isNarrow ? "90%" : undefined} height={isNarrow ? "auto" : "100%"} flexDirection="column" justifyContent="space-between">
        <Card
          bgcolor={contract ? theme.colors.white : theme.palette.grey[100]}
          flexDirection="column"
          position="relative"
          height="100%"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <Box width="100%" justifyContent="center" alignItems="center" p={2}>
            <Skeleton variant="rounded" width={210} height={20} />
          </Box>
          <Box width="100%" p={1}>
            <Skeleton variant="rounded" animation="wave" width="100%" height={20} />
          </Box>
          <Box width="100%" p={1}>
            <Skeleton variant="rounded" animation="wave" width="100%" height={20} />
          </Box>
          <Box width="100%" p={1}>
            <Skeleton variant="rounded" animation="wave" width="100%" height={20} />
          </Box>
        </Card>
      </Box>
    );
  }

  return (
    <Box flex={isNarrow ? undefined : 0.35} width={isNarrow ? "90%" : undefined} height={isNarrow ? "auto" : "100%"} flexDirection="column" justifyContent="space-between">
      <Card
        bgcolor={contract ? theme.colors.white : theme.palette.grey[100]}
        display="flex"
        flexDirection="column"
        position="relative"
        height="100%"
        width="100%"
        alignItems="center"
      >
        <Box alignItems="center" justifyContent="center" p={4} pb={0}>
          <Text fontSize={20} pl={2} fontWeight="800">
            {contract?.typeProduit === 1 && "Forfait "}
            {title}
          </Text>
        </Box>
        {showIcon && (
          <Box
            bgcolor={theme.palette.primary.main}
            width="50px"
            height="50px"
            borderRadius="50px"
            position="absolute"
            top="-15px"
            right="-15px"
            justifyContent="center"
            alignItems="center"
          >
            <div className="white-smile" style={{ width: "28px", height: "28px" }} />
          </Box>
        )}
        <Box flexDirection="column" justifyContent="center" mb={1} width="80%">
          {contract?.typeProduit === 1 && contract?.typeFacturation === 1 && (
            <>
              <Text color={theme.palette.grey[500]} fontSize={14} fontWeight="600">
                SANS ENGAGEMENT
              </Text>
              <Text color={theme.palette.grey[500]} fontSize={14} fontWeight="600">
                COFFRE-FORT NUMERIQUE
              </Text>
            </>
          )}
          {contract?.typeProduit === 1 && contract?.typeFacturation === 2 && (
            <>
              <Text color={theme.palette.grey[500]} fontSize={14} fontWeight="600">
                ABONNEMENT {contract.commitmentDuration} MOIS
              </Text>
              <Text color={theme.palette.grey[500]} fontSize={14} fontWeight="600">
                COFFRE-FORT NUMERIQUE
              </Text>
            </>
          )}
          <PricingLine contract={contract} theme={theme} />
          {!!contract?.subscriptionDate && (
            <Box flexDirection="row">
              <Text fontWeight="600" mr={2}>
                Date de souscription:
              </Text>
              <Text>{formatUTC(new Date(contract?.subscriptionDate), "dd MMMM yyyy")}</Text>
            </Box>
          )}

          {contract?.active === false && !!contract?.terminationDate && (
            <Box flexDirection="row">
              <Text fontWeight="600" color={colorPalette.red.main} mr={2}>
                Expiré depuis le :
              </Text>
              <Text color={colorPalette.red.main}>{formatUTC(new Date(contract?.terminationDate), "dd MMMM yyyy")}</Text>
            </Box>
          )}

          {!contract && title?.includes("Option") && (
            <Text color={theme.palette.grey[500]} fontSize={12} fontWeight="700" textAlign="center">
              Optez pour la tranquillité : profitez du suivi bancaire et de la relance d’impayés ! Contactez votre gestionnaire pour en bénéficier.
            </Text>
          )}
        </Box>
      </Card>
    </Box>
  );
};

export default Contracts;
